export default __webpack_public_path__ + "static/4_32-0f926125f31ecad0086c9ab40a15f342.png";